import React, { useEffect, useMemo, useRef, useState } from 'react'
import { format, addDays, subDays, getWeek, addWeeks, subWeeks, lastDayOfWeek } from 'date-fns'
import { Button, Radio, RadioGroup, FormControlLabel, FormControl } from '@material-ui/core'
import moment from 'moment'
import { useContext } from 'react'
import schedulePickupContext from '../../../Product/context/plugin/schedulePickup/schedulePickupContext'
import authContext from '../../../Product/context/auth/authContext'
import './Scheduler.css'
import { convertTime12to24, isAppleDevice } from '../../commonFunctions'

export default function Scheduler({
    selectedDate,
    setSelectedDate,
    selectedTime,
    setSelectedTime,
    pickupData,
    requestReSchedule,
    invoice,
}) {
    var count = 1
    function addDays(date, day) {
        let new_date = new Date(date.getTime())
        new_date.setDate(new_date.getDate() + day)
        return new_date
    }
    const { all_timings, getScheduleSlots, schedule_slots, last_pickup_date } =
        useContext(schedulePickupContext)
    const { user, loadUser } = useContext(authContext)
    const [currentMonth, setCurrentMonth] = useState(new Date())
    const isBidDepotProject = document.querySelector('body').classList.contains('BidAuctionDepot')
    const [startDate, setStartDate] = useState(
        requestReSchedule && requestReSchedule
            ? new Date()
            : global?.storeConfigration?.limit_pickup_days?.value
            ? addDays(
                  moment
                      .utc(
                          isBidDepotProject
                              ? invoice?.date_closed
                              : invoice?.paid_date && invoice?.paid_date != '0000-00-00 00:00:00'
                              ? invoice?.paid_date
                              : invoice?.date_closed
                              ? invoice?.date_closed
                              : new Date(),
                      )
                      .local()
                      .toDate(),
                  0,
              )
            : new Date(),
    )
    const [disabledBack, setDisabledBack] = useState(true)
    const [timeIndex, setTimeIndex] = useState(-1)
    const [breakIndex, setbreakIndex] = useState({
        start: -1,
        end: -1,
    })
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const [availableSlots, setAvailableSlots] = useState([])
    const [tempWeekDays, setTempWeekDays] = useState([])
    const [first, setFirst] = useState(false)
    const [dayOfWeek, setDayOfWeek] = useState('')
    const [limitedSlots, setLimitedSlots] = useState([])
    // const countRef = useRef(count)
    // useEffect(() => {
    //     countRef.current = count
    // })

    const [dateLimit, setDateLimit] = useState({
        start_date: new Date(),
        end_date: new Date(),
    })
    const [timings, setTimings] = useState({
        default: [],
        scheduled: [],
    })
    const dummyResponse = [
        {
            Day: 'Monday',
            Status: 'Closed',
            Day_Times: [],
        },

        {
            Day: 'Tuesday',
            Status: 'Open',
            Day_Times: [
                {
                    start_time: '10:00 AM',
                    end_time: '06:00 PM',
                },
            ],
        },

        {
            Day: 'Wednesday',
            Status: 'Open',
            Day_Times: [
                {
                    start_time: '10:00 AM',
                    end_time: '06:00 PM',
                },
            ],
        },

        {
            Day: 'Thursday',
            Status: 'Open',
            Day_Times: [
                {
                    start_time: '10:00 AM',
                    end_time: '06:00 PM',
                },
            ],
        },

        {
            Day: 'Friday',
            Status: 'Open',
            Day_Times: [
                {
                    start_time: '10:00 AM',
                    end_time: '06:00 PM',
                },
            ],
        },

        {
            Day: 'Saturday',
            Status: 'Open',
            Day_Times: [
                {
                    start_time: '10:00 AM',
                    end_time: '06:00 PM',
                },
            ],
        },

        {
            Day: 'Sunday',
            Status: 'Open',
            Day_Times: [
                {
                    start_time: '10:00 AM',
                    end_time: '06:00 PM',
                },
            ],
        },
    ]

    const handleDateChange = (event) => {
        setFirst(true)
        setSelectedTime(null)
        setSelectedDate(event.target.value)

        let formattedDate = moment(event.target.value, 'ddd DD MMM')
        setDayOfWeek(formattedDate.format('dddd'))
    }

    const handleTimeChange = (event) => {
        setFirst(true)
        setSelectedTime(event.target.value)
    }

    const changeWeekHandle = (btnType) => {
        const today = moment()
        const offset = btnType === 'prev' ? -7 : 7
        const newStartDate = addDays(startDate, offset)
        setStartDate(newStartDate)

        if (moment(newStartDate).isSame(today, 'day')) {
            setDisabledBack(true)
        } else {
            setCurrentMonth(
                btnType === 'prev' ? subWeeks(currentMonth, 1) : addWeeks(currentMonth, 1),
            )
            setDisabledBack(false)
        }
    }

    const reschduleWeekDays = () => {
        const dateFormat = 'EEE d MMM yyyy'
        const weekDays = []
        const temp_week_days = []
        const today = moment()
        // count = 1
        let temp_count = 1
        let daysCount = global?.storeConfigration?.limit_pickup_days?.value ? 8 : 7
        for (let i = 0; i < daysCount; i++) {
            const selDay = addDays(startDate, i)
            const formattedDate = format(selDay, dateFormat)
            var day = formattedDate?.split(' ')[0]
            let date = formattedDate?.split(' ')[1]
            let month = formattedDate?.split(' ')[2]

            if (
                moment(selDay).isBefore(today, 'day') &&
                !global?.storeConfigration?.limit_pickup_days?.value
            ) {
                console.log('Older Date')
            } else {
                if (global?.storeConfigration?.limit_pickup_days?.value) {
                    if (
                        temp_count <= parseInt(global?.storeConfigration?.limit_pickup_days?.value)
                    ) {
                        if (
                            timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))
                                ?.Status === 'Closed'
                        )
                            continue
                        else {
                            // temp_week_days.push(day)
                            temp_count++
                        }
                    } else {
                        console.log(temp_count)
                        break
                    }
                }
                let disable = timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))
                    ? timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))?.Status ===
                      'Closed'
                        ? true
                        : new Date(selDay) < new Date(moment().format('YYYY-MM-DD'))
                        ? true
                        : false
                    : false
                weekDays.push(
                    <FormControlLabel
                        className={`${formattedDate == selectedDate ? 'selected' : ''}`}
                        key={i}
                        value={formattedDate}
                        control={<Radio />}
                        label={
                            <div className="dayPreview">
                                <span>{day}</span>
                                <span>{date}</span>
                                <span>{month}</span>
                            </div>
                        }
                        disabled={disable}
                    />,
                )
                if (!disable) {
                    temp_week_days.push(day)
                }
                // if (
                //     timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))?.Status !==
                //         'Closed' &&
                //     count <= parseInt(global.pluginConfiguration?.limit_pickup_days?.client_key)
                // ) {
                //     count++
                // }
            }
        }

        if (global?.storeConfigration?.limit_pickup_days?.value && !first) {
            if (!temp_week_days.length) {
                setSelectedDate(null)
            } else {
                setSelectedDate(
                    format(
                        pickupData?.booking_date
                            ? new Date(
                                  moment
                                      .utc(pickupData?.booking_date)
                                      .local()
                                      .format('MM/DD/YYYY hh:mm A'),
                              )
                            : getDates(
                                  1,
                                  all_timings?.default_timings[0]?.general?.find((ele) =>
                                      ele.Day?.includes(temp_week_days[0]),
                                  )?.Day,
                              ),
                        'EEE d MMM yyyy',
                    ),
                )
                setSelectedTime(
                    pickupData?.booking_date
                        ? format(
                              pickupData?.booking_date
                                  ? new Date(
                                        moment
                                            .utc(pickupData?.booking_date)
                                            .local()
                                            .format('MM/DD/YYYY hh:mm A'),
                                    )
                                  : getDates(
                                        1,
                                        all_timings?.default_timings[0]?.general?.find((ele) =>
                                            ele.Day?.includes(
                                                temp_week_days[temp_week_days.length - 1],
                                            ),
                                        )?.Day,
                                    ),
                              'hh:mm a',
                          )
                        : null,
                )
            }
        }
        return (
            <FormControl className="schedulerDate">
                <RadioGroup
                    aria-label="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={selectedDate}
                    onChange={handleDateChange}
                >
                    {weekDays}
                </RadioGroup>
            </FormControl>
        )
    }

    const renderWeekDays = () => {
        const dateFormat = 'EEE d MMM yyyy'
        const weekDays = []
        const temp_week_days = []
        const today = moment()
        // count = 1
        let temp_count = 1
        let daysCount = global?.storeConfigration?.limit_pickup_days?.value
            ? isBidDepotProject
                ? 10
                : 8
            : 7
        const ifCond = isBidDepotProject
            ? temp_count < parseInt(global?.storeConfigration?.limit_pickup_days?.value) ||
              (weekDays.length != 7 &&
                  weekDays.length < parseInt(global?.storeConfigration?.limit_pickup_days?.value))
            : temp_count <= parseInt(global?.storeConfigration?.limit_pickup_days?.value)

        for (let i = 0; i < daysCount; i++) {
            const selDay = addDays(startDate, i)
            const formattedDate = format(selDay, dateFormat)
            var day = formattedDate?.split(' ')[0]
            let date = formattedDate?.split(' ')[1]
            let month = formattedDate?.split(' ')[2]

            if (
                moment(selDay).isBefore(today, 'day') &&
                !global?.storeConfigration?.limit_pickup_days?.value
            ) {
                console.log('Older Date')
            } else {
                if (global?.storeConfigration?.limit_pickup_days?.value) {
                    if (ifCond) {
                        if (
                            timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))
                                ?.Status === 'Closed'
                        )
                            continue
                        else {
                            // temp_week_days.push(day)
                            temp_count++
                        }
                    } else {
                        console.log(temp_count)
                        break
                    }
                }
                let disable = timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))
                    ? timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))?.Status ===
                      'Closed'
                        ? true
                        : moment(selDay, 'YYYY-MM-DD').isBefore(moment(), 'day')
                        ? true
                        : false
                    : false
                weekDays.push(
                    <FormControlLabel
                        className={`${formattedDate == selectedDate ? 'selected' : ''}`}
                        key={i}
                        value={formattedDate}
                        control={<Radio />}
                        label={
                            <div className="dayPreview">
                                <span>{day}</span>
                                <span>{date}</span>
                                <span>{month}</span>
                            </div>
                        }
                        disabled={disable}
                    />,
                )
                if (!disable) {
                    temp_week_days.push(day)
                }
                // if (
                //     timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))?.Status !==
                //         'Closed' &&
                //     count <= parseInt(global.pluginConfiguration?.limit_pickup_days?.client_key)
                // ) {
                //     count++
                // }
            }
        }
        if (isBidDepotProject && weekDays.length > 7) {
            weekDays.pop()
        }

        if (global?.storeConfigration?.limit_pickup_days?.value && !first) {
            if (!temp_week_days.length) {
                setSelectedDate(null)
            } else {
                setSelectedDate(
                    format(
                        pickupData?.booking_date
                            ? new Date(
                                  moment
                                      .utc(pickupData?.booking_date)
                                      .local()
                                      .format('MM/DD/YYYY hh:mm A'),
                              )
                            : getDates(
                                  1,
                                  all_timings?.default_timings[0]?.general?.find(
                                      (ele) =>
                                          ele.Day?.includes(temp_week_days[0]) &&
                                          ele.Status !== 'Closed',
                                  )?.Day,
                              ),
                        'EEE d MMM yyyy',
                    ),
                )
                setSelectedTime(
                    pickupData?.booking_date
                        ? format(
                              pickupData?.booking_date
                                  ? new Date(
                                        moment
                                            .utc(pickupData?.booking_date)
                                            .local()
                                            .format('MM/DD/YYYY hh:mm A'),
                                    )
                                  : getDates(
                                        1,
                                        all_timings?.default_timings[0]?.general?.find((ele) =>
                                            ele.Day?.includes(
                                                temp_week_days[temp_week_days.length - 1],
                                            ),
                                        )?.Day,
                                    ),
                              'hh:mm a',
                          )
                        : null,
                )
            }
        }
        return (
            <FormControl className="schedulerDate">
                <RadioGroup
                    aria-label="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={selectedDate}
                    onChange={handleDateChange}
                >
                    {weekDays}
                </RadioGroup>
            </FormControl>
        )
    }

    useMemo(() => {
        renderWeekDays()
    }, [startDate])

    const generateTimeSlots = () => {
        let day = selectedDate?.split(' ')[0]
        let sTime =
            timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))?.Day_Times[0]
                ?.start_time || '12:00 AM'
        let eTime =
            timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))?.Day_Times[0]
                ?.end_time || '11:59 PM'
        // if (
        //     localStorage.getItem('Browsertype') == 'Safari' ||
        //     localStorage.getItem('Browsertype') == 'Mobile Safari'
        // ) {
        sTime = isAppleDevice() || isBargainsProject ? convertTime12to24(sTime) : sTime
        eTime = isAppleDevice() || isBargainsProject ? convertTime12to24(eTime) : eTime
        // }
        const sDate = new Date(`2000-01-01 ${sTime}`)
        const eDate = new Date(`2000-01-01 ${eTime}`)

        const timeSlots = []

        const interval =
            60 *
            (timings?.default[0]?.pickup_minutes != 0 ? timings?.default[0]?.pickup_minutes : 5) *
            1000
        let currentSlot = sDate

        while (currentSlot <= eDate) {
            const slotStart = currentSlot.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
            })

            timeSlots.push(slotStart)
            currentSlot = new Date(currentSlot.getTime() + interval)
        }

        return timeSlots
    }

    const generateLimitedSlots = () => {
        return schedule_slots.map((item) => {
            if (
                Number(all_timings?.all_locations[0]?.range_key[0]?.pickup_limit) <= item.count &&
                (isBidDepotProject ? item.user_id !== user.id : true)
            ) {
                return isAppleDevice() || isBargainsProject
                    ? convertTime12to24(item.booking_date)
                    : item.booking_date
                // const time = item.booking_date
                // if (isAppleDevice()) {
                //     console.log('apple ---')
                //     return convertTime12to24(time)
                // }
                // // windows
                // const [hour, minute] = time.split(':')
                // return `${hour.padStart(2, '0')}:${minute}`
            }
        })
    }

    useEffect(() => {
        if (selectedDate) {
            const date = moment(selectedDate).format('YYYY-MM-DD')

            // const isoString = date.format('')
            getScheduleSlots({
                booking_start_date: date,
                site_id: invoice?.site_id,
                user_id: user?.id,
                need_last_pickup: isBidDepotProject ? 1 : 0,
            })
        }

        setAvailableSlots(generateTimeSlots())
    }, [selectedDate, timings])

    useEffect(() => {
        setLimitedSlots(generateLimitedSlots())
    }, [schedule_slots])

    useEffect(() => {
        if (
            global.storeDetails?.theme == 20 &&
            timings?.default[0]?.time_cut_off_enable == 1 &&
            format(new Date(), 'EEE d MMM yyyy') === selectedDate
        ) {
            let time_cut = timings?.default[0]?.time_cut
            let currentTime = moment().format('hh:mm A')

            let isCurrentTimeAfterOrEqual = moment(currentTime, 'hh:mm A').isSameOrAfter(
                moment(time_cut, 'hh:mm A'),
            )
            if (isCurrentTimeAfterOrEqual) {
                setTimeIndex(-1)
            } else {
                setTimeIndex(availableSlots.length)
            }

            // let t_index = availableSlots.findIndex((val) => val === time_cut)
            // setTimeIndex(t_index)
        } else if (
            invoice?.paid_date &&
            invoice?.paid_date != '0000-00-00 00:00:00' &&
            format(new Date(), 'EEE d MMM yyyy') === selectedDate &&
            timings?.default[0]?.time_cut_off_enable == 1
        ) {
            let time_cut = timings?.default[0]?.time_cut
            let t_index = availableSlots.findIndex((val) => val === time_cut)
            setTimeIndex(t_index)
        } else {
            setTimeIndex(-1)
        }

        if (
            timings?.default[0]?.break_from_date &&
            timings?.default[0]?.break_to_date &&
            timings?.default[0]?.break_time_enable == 1
        ) {
            let fromDate = timings?.default[0]?.break_from_date
            let toDate = timings?.default[0]?.break_to_date
            if (isAppleDevice() || isBargainsProject) {
                fromDate = convertTime12to24(timings?.default[0]?.break_from_date)
                toDate = convertTime12to24(timings?.default[0]?.break_to_date)
            }

            let startIndex = availableSlots.findIndex(
                (val) =>
                    (isAppleDevice() || isBargainsProject ? convertTime12to24(val) : val) ===
                    fromDate,
            )

            let endIndex = availableSlots.findIndex(
                (val) =>
                    (isAppleDevice() || isBargainsProject ? convertTime12to24(val) : val) ===
                    toDate,
            )

            setbreakIndex({
                start: startIndex === -1 ? 0 : startIndex,
                end: endIndex === -1 ? availableSlots.length - 1 : endIndex,
            })
        }
    }, [availableSlots])

    const disableBreakTime = (index) => {
        let disabled = false
        if (breakIndex.start > -1 && breakIndex.end > -1)
            if (index >= breakIndex.start && index <= breakIndex.end) {
                disabled = true
            }
        return disabled
    }

    function getDates(k, day = 'Monday') {
        const day_num = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
        ].indexOf(day.toLowerCase())

        let today = new Date()
        let new_day = today

        while (new_day.getDay() !== day_num || new_day < today) {
            new_day = addDays(new_day, 1)
        }

        return addDays(new_day, 0)
    }

    useEffect(() => {
        if (all_timings?.default_timings) {
            setTimings({
                ...timings,
                default: all_timings?.default_timings,
                scheduled: all_timings?.scheduled_timings,
            })
            if (!global?.storeConfigration?.limit_pickup_days?.value) {
                setSelectedDate(
                    format(
                        pickupData?.booking_date
                            ? new Date(
                                  moment
                                      .utc(pickupData?.booking_date)
                                      .local()
                                      .format('MM/DD/YYYY hh:mm A'),
                              )
                            : getDates(
                                  1,
                                  all_timings?.default_timings[0]?.general?.find(
                                      (ele) => ele.Status === 'Open',
                                  )?.Day,
                              ),
                        'EEE d MMM yyyy',
                    ),
                )
                setSelectedTime(
                    pickupData?.booking_date
                        ? format(
                              pickupData?.booking_date
                                  ? new Date(
                                        moment
                                            .utc(pickupData?.booking_date)
                                            .local()
                                            .format('MM/DD/YYYY hh:mm A'),
                                    )
                                  : getDates(
                                        1,
                                        all_timings?.default_timings[0]?.general?.find(
                                            (ele) => ele.Status === 'Open',
                                        )?.Day,
                                    ),
                              'hh:mm a',
                          )
                        : null,
                )
            }
        }
    }, [all_timings])
    function isBeforeNowWithSelectedDate(d, selectedDate, isAppleDevice) {
        const currentDate = moment()
        const timeString = isAppleDevice || isBargainsProject ? convertTime12to24(d) : d
        // Parse today's date with the given time
        const targetMoment = moment(
            `${currentDate.format('YYYY-MM-DD')} ${timeString}`,
            ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD hh:mm A'],
            true, // strict mode
        )

        // Parse selectedDate
        const selected = moment(selectedDate, 'YYYY-MM-DD', true)

        return (
            targetMoment.isValid() &&
            selected.isValid() &&
            targetMoment.isBefore(currentDate) &&
            selected.isSameOrBefore(currentDate, 'day')
        )
    }

    return (
        <div className="scheduler">
            {global?.storeConfigration?.limit_pickup_days?.value ? null : (
                <div className="schedulerTop">
                    Calendar
                    <div className="schedulerActions">
                        <Button
                            className="schedulerMove"
                            onClick={() => changeWeekHandle('prev')}
                            disabled={disabledBack}
                        >
                            <span className="material-icons">navigate_before</span>
                        </Button>

                        <Button className="schedulerMove" onClick={() => changeWeekHandle('next')}>
                            <span className="material-icons">navigate_next</span>
                        </Button>
                    </div>
                </div>
            )}
            <div className="schedulerMain">
                {isBidDepotProject && last_pickup_date !== '' && selectedDate ? (
                    <>
                        <p>{`Last Booking Scheduled On : ${moment
                            .utc(last_pickup_date?.booking_date)
                            .local()
                            .format('dddd, MMM Do [at] h:mm A')}`}</p>
                        <p>
                            <b>Reminder:</b> Add <b>any new invoices</b> to your
                            <b> existing pickup time.</b> <br />
                            <b>Unscheduled invoices won’t be ready</b> upon arrival.
                        </p>
                    </>
                ) : (
                    ''
                )}
                {renderWeekDays()}
                <div className="schedulerTime">
                    <h4 className="stTitle">{selectedDate}</h4>
                    {selectedDate ? (
                        <div className="timeUnits">
                            <FormControl>
                                <RadioGroup
                                    aria-label="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedTime}
                                    onChange={handleTimeChange}
                                >
                                    {availableSlots?.map((d, i) =>
                                        timeIndex == -1 &&
                                        format(new Date(), 'EEE d MMM yyyy') ===
                                            selectedDate ? null : timeIndex !== -1 &&
                                          i > timeIndex ? null : (
                                            <FormControlLabel
                                                key={i}
                                                value={d}
                                                control={
                                                    <Radio
                                                        disabled={
                                                            isBeforeNowWithSelectedDate(
                                                                d,
                                                                selectedDate,
                                                                isAppleDevice,
                                                            ) ||
                                                            limitedSlots.find(
                                                                (item) =>
                                                                    item ==
                                                                    (isAppleDevice() ||
                                                                    isBargainsProject
                                                                        ? convertTime12to24(d)
                                                                        : d),
                                                            ) ||
                                                            disableBreakTime(i)
                                                        }
                                                    />
                                                }
                                                label={
                                                    (isAppleDevice() || isBargainsProject) &&
                                                    !(global.storeDetails?.theme === 20) &&
                                                    !(global.storeDetails?.theme === 18)
                                                        ? convertTime12to24(d)
                                                        : d
                                                }
                                            />
                                        ),
                                    )}
                                </RadioGroup>
                                {timeIndex == -1 &&
                                format(new Date(), 'EEE d MMM yyyy') === selectedDate ? (
                                    <p>No Slots Available Today!</p>
                                ) : (
                                    ''
                                )}
                            </FormControl>
                        </div>
                    ) : global?.storeConfigration?.limit_pickup_days?.value ? (
                        <>
                            <p>Your Scheduling Time Is Over!</p>
                            {global?.storeConfigration?.bodyClass?.value === 'hawaii' ? (
                                <p>Please contact us at 808-260-8979</p>
                            ) : (
                                ''
                            )}
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
